export default __webpack_public_path__ + "static/media/correct.bfd00a99.mp3";